<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import PiIcon from '@uiKit/elements/PiIcon.vue'

interface Props {
  label?: string
  required?: boolean
  optional?: boolean
  error?: string
  helperText?: string
}

withDefaults(defineProps<Props>(), {
  required: false,
  optional: false,
})
</script>

<template>
  <Box direction="col" gap="2" class="form-field">
    <Text v-if="label" is="label" type="body" weight="medium" color="default">
      {{ label }}
      <Text v-if="required" is="span" type="body" color="danger" aria-hidden="true">*</Text>
      <Text v-else-if="optional" is="span" type="body" color="muted">(optional)</Text>
    </Text>

    <slot />

    <Box v-if="error" align="center" gap="1" class="form-field__error" role="alert">
      <PiIcon name="exclamation-circle" class="form-field__error-icon" />
      <Text type="caption" color="danger">{{ error }}</Text>
    </Box>
    <Text v-else-if="helperText" type="caption" color="muted">
      {{ helperText }}
    </Text>
  </Box>
</template>

<style scoped>
.form-field {
  width: 100%;
}

.form-field__error {
  margin-top: 0.125rem;
}

.form-field__error-icon {
  color: var(--p-danger-600);
  font-size: 12px;
}
</style>
